import React from "react";
import { Subscription } from "../../types/plans";

interface PricingCardProps {
  plan: Subscription;
  isHighlighted: boolean;
  onSelectPlan: (plan: Subscription) => void;
  hasActiveSubscription: boolean;
  isCreatingSetupIntent: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  plan,
  isHighlighted,
  onSelectPlan,
  hasActiveSubscription,
  isCreatingSetupIntent,
}) => {
  return (
    <div className="col-xl col-lg-4 col-md-6 col-sm-12 px-3">
      <div
        className={`card h-100 border-0 shadow-lg position-relative pricing-card ${
          isHighlighted ? "highlighted" : ""
        }`}
      >
        {isHighlighted && (
          <div className="position-absolute -top-5 start-50 translate-middle-x z-20">
            <span className="badge rounded-pill px-3 py-2 fw-semibold pricing-badge">
              Most Popular
            </span>
          </div>
        )}

        <div className="card-body p-4 d-flex flex-column">
          {/* Plan Header */}
          <div className="text-start mb-4">
            <h3 className="card-title fw-bold mb-3 pricing-title">
              {plan.name}
            </h3>

            <div className="mb-3">
              {plan.price.amount ? (
                <div className="d-flex align-items-baseline gap-1">
                  <span className="display-5 fw-bold text-uppercase pricing-price">
                    {plan.price.currency} {plan.price.amount}
                  </span>
                  <span className="text-muted">/{plan.interval}</span>
                </div>
              ) : (
                <div className="d-flex align-items-baseline">
                  <span className="display-6 fw-bold pricing-price">
                    Contact Sales
                  </span>
                </div>
              )}
            </div>

            {plan.description && (
              <p className="text-muted mb-0 pricing-description">
                {plan.description}
              </p>
            )}
          </div>

          {/* Features List */}
          <div className="flex-grow-1 mb-4">
            <ul className="list-unstyled">
              {plan.features?.map((feature, index) => (
                <li
                  key={index}
                  className="d-flex align-items-start gap-3 mb-3 pricing-feature"
                >
                  <i className="fas fa-check-circle mt-1"></i>
                  <span className="text-muted">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Action Button */}
          <div className="mt-auto">
            <button
              disabled={hasActiveSubscription || isCreatingSetupIntent}
              onClick={() => onSelectPlan(plan)}
              className={`p w-100 py-3 fw-semibold rounded-pill ${
                isHighlighted ? "pricing-btn-primary" : "pricing-btn-dark"
              } ${
                hasActiveSubscription || isCreatingSetupIntent
                  ? "pricing-btn-disabled"
                  : ""
              } `}
            >
              {plan.price.amount ? "Subscribe" : "Contact Sales"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
